// removed by extract-text-webpack-plugin
module.exports = {"Beer":"FavBeer__Beer__-hash-base-64-5-","TextContainer":"FavBeer__TextContainer__-hash-base-64-5-","Name":"FavBeer__Name__-hash-base-64-5-","Tagline":"FavBeer__Tagline__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/FavBeer/FavBeer.scss
// module id = 198
// module chunks = 0